import React from "react";
import PropTypes from "prop-types";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import s from "./Inbox.css";
import { Grid, Row, Col } from "react-bootstrap";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
// Components
import SideMenu from "./SideMenu";
import Inbox from "./Inbox";

class InboxChildContainer extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    registeredType: PropTypes.string,
    initialData: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired, // from withRouter
    isHosting: PropTypes.bool, // Add new prop type
  };

  static defaultProps = {
    isHosting: false, // Default value
  };
  render() {
    const { allThreads, isHosting } = this.props;

    return (
      <>
        <Grid fluid className={"dashBoardContainer"}>
          <Row>
            <Col xs={12} sm={12} md={12} lg={12}>
              <div className={"dashBoardListingGrid"}>
                <SideMenu />
                <Inbox allThreads={allThreads} isHosting={isHosting} />
              </div>
            </Col>
          </Row>
        </Grid>
      </>
    );
  }
}

const mapState = (state) => ({
  registeredType: state.account.data.userData.type,
});

const mapDispatch = {};

export default injectIntl(
  withStyles(s)(connect(mapState, mapDispatch)(InboxChildContainer))
);
